import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cml-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
